const EVENTI = ['click', 'keydown', 'mousemove', 'scroll', 'touchstart'] as const

/**
 * Chiude la sessione dopo `minuti` di inattivita. Ogni interazione riarma il
 * conto. Ritorna la funzione per fermarlo (da chiamare all'unmount).
 */
export function avviaScadenzaInattivita(minuti: number, onScadenza: () => void): () => void {
  let timer: ReturnType<typeof setTimeout>

  const riarma = () => {
    clearTimeout(timer)
    timer = setTimeout(onScadenza, minuti * 60 * 1000)
  }

  for (const e of EVENTI) window.addEventListener(e, riarma, { passive: true })
  riarma()

  return () => {
    clearTimeout(timer)
    for (const e of EVENTI) window.removeEventListener(e, riarma)
  }
}
